import React, { useState, Fragment, Component } from 'react'
import TeamBloc from "../Blocs/TeamBloc"
import { config } from "../../../../../helpers/config_global"
import MKIDatatable from '../../../../../modules/mki-datatable/lib'
import { cancelToken } from "../../../../../services/adapters/master/penialian360Service"
import apiResponse from '../../../../../services/apiResponse'
import { ConfirmAlert } from "../../../../../helpers/ui/alert";
import CustomSelect from "../../../../../helpers/ui/CustomSelect"
import moment from "moment"
import { Redirect } from "react-router-dom"
import 'moment/locale/id'
import {
  AvForm,
  AvGroup,
  AvInput,
  AvField,
  AvCheckboxGroup,
  AvCheckbox,
} from "availity-reactstrap-validation";

import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    Tooltip,
    TabPane,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Label,
    Spinner
} from "reactstrap"

class TeamComponent extends Component
{
    teamBloc = new TeamBloc();

    source
    historyTable = 'team360Active'
    defaultOrder = 'ms360_team_id'
    defaultSize = 10
    defaultSort = 'desc'
    configDatatable = {
        ...config('datatable'),
        sort: {
            column: this.defaultOrder,
            order: this.defaultSort
        }
    }


    constructor(props) {
        super(props)
        this.state = {
            percentageStatus: 0.0,
            modalConfirm: false,
            loadingGenerate: false,
            messageFailed: "Data gagal disimpan",
            period: {},
            loadingLeader: false,
            redirectBack: false,
            period_uuid: "",
            leaders: [],
            organizations: [],
            organizationsFilters: [],
            loadingContent: true,
            periodUuid: "",
            inactiveUuid: "",
            dataForm: {},
            obj: null,
            modalShow: false,
            modalToggle: false,
            tooltip: false,
            detailUuid: null,
            defaultSize: 10,
            rows: [],
            totalRow: 0,
            loadingTable: true,
            workUnitFilter: 'all',
            filter: sessionStorage.getItem(this.historyTable) ?
                JSON.parse(sessionStorage.getItem(this.historyTable)) :
                {
                    filter_value: "",
                    page_number: 1,
                    page_size: this.defaultSize,
                    sort_order: {
                        column: this.defaultOrder,
                        order: this.defaultSort
                    }
                }
        }
    }

    toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

    loadData = async () => {
        /* history Datatable */
        sessionStorage.setItem(this.historyTable, JSON.stringify(this.state.filter))

        /* kirim ke server */
        let offset = (this.state.filter.page_number-1)*this.state.filter.page_size
        if(this.state.defaultSize!==this.state.filter.page_size) {
            this.setState({
                defaultSize: this.state.filter.page_size
            })
            offset = 0
            this.configDatatable.page_number = 1
        }
        const queryParams = new URLSearchParams(window.location.search);
        const uuid = queryParams.get('uuid')
        const query = {
            search: this.state.filter.filter_value,
            limit: this.state.filter.page_size,
            offset: offset,
            order: this.state.filter.sort_order.column,
            sort: this.state.filter.sort_order.order,
            status: 1,
            period_uuid: uuid,
            work_unit: this.state.workUnitFilter
        }
        await this.teamBloc.fetchTeamList(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadData()
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault();
        var userdata = JSON.parse(localStorage.getItem("userdata"));
        var create_uuid = userdata.employee_uuid;
        this.setState({
            dataForm: {
              ...values
            },
            confirm: true,
        });
    };

     confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:
        }
        this.setState(forState)
    }


    componentDidMount() {

        this.loadContent()

        this.teamBloc.timkerjaTeamListChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingTable: false
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        loadingTable: true
                    })
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    this.setState({
                        totalRow: response.total,
                        rows: response.result,
                        loadingTable: false
                    })
                    break
                case apiResponse.ERROR:

                    break
                default:
                    break
            }
        })

        this.teamBloc.timkerjaTeamCreateChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    const status = result.data.status
                    this.setState({
                        failed: status === false,
                        loading: false,
                        success: status,
                        modalShow: false,
                        modalToggle: false,
                        messageFailed: status ? '' : response?.message,
                        obj: null,
                        percentageStatus: 0.00
                    });
                    if(status){
                        this.setTokenAPI()
                    }
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                        percentageStatus: 0.00
                    });
                    break
                default:
                    break
            }
        })

        this.teamBloc.timkerjaDeleteChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                        modalShow: false,
                        modalToggle: false,
                        inactiveUuid: '',
                        obj: null
                    });
                    this.setTokenAPI()
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.teamBloc.timkerjaOrgranizationChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingContent: false
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        loadingContent: true
                    })
                    break
                case apiResponse.COMPLETED:
                    const queryParams = new URLSearchParams(window.location.search);
                    const uuid = queryParams.get('uuid')
                    const response = result.data.response
                    const organizationsResp = response.organizations
                    const opts = [
                        { label: 'Semua Unit Kerja', value: 'all' },
                        ...Object.values(response.organizations)
                    ];
                    this.setState({
                        period_uuid: uuid,
                        organizations: organizationsResp,
                        period: response.period,
                        organizationsFilters: opts,
                        loadingContent: false
                    })
                    this.setTokenAPI()
                    break
                case apiResponse.ERROR:

                    break
                default:
                    break
            }
        })

         this.teamBloc.timkerjaLeaderChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingLeader: false
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        loadingLeader: true
                    })
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    this.setState({
                        leaders: response.leaders,
                        loadingLeader: false
                    })
                    break
                case apiResponse.ERROR:

                    break
                default:
                    break
            }
        })

        this.teamBloc.timkerjaGenerateChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingGenerate: false
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        loadingGenerate: true
                    })
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    setTimeout(() => {
                        this.setState({
                            loadingGenerate: false,
                            detailUuid: response.team_uuid,
                            obj: null,
                        });
                    }, 750)
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loadingGenerate: false,
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

    }

    columns = [
        {
            key: "ms360_team_name",
            text: "NAMA TIM",
            className: "ms360_team_name",
            sortable: true,
        },
        {
            key: "ms360_team_alias",
            text: "NAMA ALIAS",
            className: "ms360_team_alias",
            sortable: true,
        },
        {
            key: "employee_full_name",
            text: "KETUA TIM",
            className: "employee_full_name",
            sortable: true,
        },
        {
            key: "total_member",
            text: "TOTAL MAPPING",
            className: "total_member",
            sortable: false,
            align: 'center',
            cell: record => {
                const total = parseInt(record.total_member);
                return (<span className="badge bg-success">{total}</span>)
            }
        },
        {
            key: "action",
            text: "AKSI",
            className: "action",
            width: 120,
            sortable: false,
            align: 'center',
            cell: record => {
                const thisId = record.ms360_team_uuid;
                const total = parseInt(record.total_member);
                return (
                    <Fragment>
                        <span>
                            <button
                                className="btn btn-primary btn-sm"
                                id={"detail-" + thisId}
                                onClick={() => {
                                    if(parseInt(total) > 0){
                                        this.setState({
                                            detailUuid: thisId,
                                            obj: record
                                        })
                                    }else{
                                         this.setState({
                                            modalConfirm: true,
                                            obj: record
                                        })
                                    }
                                }}
                                style={{
                                    marginRight: '2px',
                                    padding: '2px 5px'
                                }}>
                               <i className="uil uil-users-alt"></i>
                            </button>
                            <Tooltip
                                style={{
                                    marginBottom: 2
                                }}
                                placement="top" isOpen={this.state["detail" + thisId]} target={"detail-" + thisId}
                                toggle={() => {
                                    this.setState({
                                        ["detail" + thisId] : !this.state["detail" + thisId]
                                    })
                                }}
                            >Mapping Tim</Tooltip>
                        </span>
                        <span>
                            <button
                                className="btn btn-warning btn-sm"
                                id={"update-" + thisId}
                                onClick={async () => {
                                    this.setState({
                                        modalShow: true,
                                        obj: record,
                                        updateUuid: thisId
                                    })
                                    await this.teamBloc.fetchLeader({ uuid: record?.ms360_team_work_unit_uuid })
                                }}
                                style={{
                                    marginRight: '2px',
                                    padding: '2px 5px'
                                }}>
                                    <i className="uil-pen"></i>
                            </button>
                            <Tooltip
                                style={{
                                    marginBottom: 2
                                }}
                                placement="top" isOpen={this.state["update" + thisId]} target={"update-" + thisId}
                                toggle={() => {
                                    this.setState({
                                        ["update" + thisId] : !this.state["update" + thisId]
                                    })
                                }}
                            >Perbaharui</Tooltip>
                        </span>
                        <span>
                            <button
                                className="btn btn-danger btn-sm"
                                id={"delete-" + thisId}
                                onClick={() => {
                                    this.setState({
                                        inactiveUuid: record.ms360_team_uuid,
                                        confirm: true
                                    })
                                }}
                                style={{
                                    marginRight: '2px',
                                    padding: '2px 5px'
                                }}>
                                <i className="uil-trash-alt"></i>
                            </button>
                            <Tooltip
                                style={{
                                    marginBottom: 2
                                }}
                                placement="top" isOpen={this.state["delete" + thisId]} target={"delete-" + thisId}
                                toggle={() => {
                                    this.setState({
                                        ["delete" + thisId] : !this.state["delete" + thisId]
                                    })
                                }}
                            >Hapus</Tooltip>
                        </span>
                    </Fragment>
                )
            }
        }
    ]

    loadContent = async () => {
        const queryParams = new URLSearchParams(window.location.search);
        const uuid = queryParams.get('uuid')
        await this.teamBloc.fetchOrganization({ uuid: uuid })
    }

    submitData = async () => {
        if(this.state.inactiveUuid !== undefined && this.state.inactiveUuid !== null && this.state.inactiveUuid !== ''){
            await this.teamBloc.fetchTeamDelete({ uuid: this.state.inactiveUuid })
        }else{

            const dataForm = this.state.dataForm;
            const formData = new FormData();

            if(this.state.obj !== undefined && this.state.obj !== null){
                formData.append("uuid", this.state.obj.ms360_team_uuid ?? "");
            }

            formData.append("period_uuid", this.state.period_uuid);
            formData.append("work_unit_uuid", dataForm.ms360_team_work_unit_uuid);
            formData.append("alias", dataForm.ms360_team_alias);

            if(dataForm.ms360_team_leader_uuid !== undefined && dataForm.ms360_team_leader_uuid !== null){
                formData.append("leader_uuid", dataForm.ms360_team_leader_uuid);
            }

            await this.teamBloc.fetchTeamCreate(formData)
        }
    };

    handleUnitKerja =  (opt) => {
        this.setState({ workUnitFilter: opt.value })
        setTimeout(() =>  {
            this.setTokenAPI()
        }, 500)
    }

    // mapping = async () => {
    //     const formData = new FormData();
    //     const team_uuid = this.state.obj?.ms360_team_uuid
    //     formData.append("uuid", team_uuid ?? "")
    //     await this.teamBloc.fetchGenerate(formData)
    // }

    mapping = async () => {


        const setProgress = (value) => {
            this.setState({ percentageStatus: value })
        };

        setProgress(20);

        // Let browser render 20%
        await new Promise(resolve => requestAnimationFrame(resolve));

        let progress = 20;

        // Simulated progress while API is running
        const interval = setInterval(() => {
            if (progress < 95) {
                progress += 1;
                setProgress(progress);
            }
        }, 200);

        try {
            const formData = new FormData();

            const team_uuid = this.state.obj?.ms360_team_uuid;

            formData.append("uuid", team_uuid ?? "");

            await this.teamBloc.fetchGenerate(formData);

            // API completed
            clearInterval(interval);

            setProgress(99);

            await new Promise(resolve => setTimeout(resolve, 300));

            setProgress(100);

        } catch (error) {
            clearInterval(interval);

            console.error(error);

            throw error;
        }
    };


    componentWillUnmount(){
        this.teamBloc.timkerjaMembersChannel.unsubscribe()
        this.teamBloc.timkerjaTeamCreateChannel.unsubscribe()
        this.teamBloc.timkerjaDeleteChannel.unsubscribe()
        this.teamBloc.timkerjaLeaderChannel.unsubscribe()
        this.teamBloc.timkerjaGenerateChannel.unsubscribe()
    }

    render(){
        return (
            <Fragment>
                { this.state.loadingContent ? <>
                    <div className='card'>
                        <div className='card-body p-5 text-center'>
                            <Spinner size="sm" className="me-1" />
                            Memuat Data...
                        </div>
                    </div>
                </> : <>
                    <Container fluid>
                        <Row>
                            <Col xs="12">
                                <Card className="">
                                    <CardBody>
                                        <div className="float-end">
                                            <Button onClick={() => { this.setState({ redirectBack:true }) }} color="secondary" className='me-2'>
                                                <i className="uil-arrow-left me-2"></i>Kembali
                                            </Button>
                                            <Button onClick={() => { this.setState({ modalShow:true, obj:null }) }} color="primary">
                                                <i className="uil-plus me-2"></i>Tambah Data
                                            </Button>
                                        </div>
                                        <CardTitle>Daftar Tim Penialian 360  ({`Periode : ${moment(this.state.period.ms360_period_date_start).format('DD MMMM YYYY')} s/d ${moment(this.state.period.ms360_period_date_end).format('DD MMMM YYYY')}`})</CardTitle>
                                        <CardSubtitle className="mb-3">
                                            Kelola Tim Penialian 360
                                        </CardSubtitle>
                                        <hr />

                                       <div className='mb-4 mt-2'>
                                            <div className='row'>
                                                <div className='col-md-7'>
                                                    <div className="row mb-3">
                                                        <label for="" className="col-sm-2 col-form-label">
                                                            Filter Unit Kerja
                                                        </label>
                                                        <div className="col-sm-9">
                                                            <CustomSelect
                                                                isAvForm={false}
                                                                name={`work_unit_uuid_filter`}
                                                                id={`work_unit_uuid_filter`}
                                                                errorMessage="Pilih Filter Unit Kerja"
                                                                options={this.state.organizationsFilters}
                                                                validate={{ required: { value: false } }}
                                                                placeholder="Pilih Filter Unit Kerja"
                                                                isLoading={this.state.loadingContent}
                                                                defaultValue={this.state.workUnitFilter}
                                                                onChange={(opt)=> this.handleUnitKerja(opt)}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <MKIDatatable
                                            className={this.configDatatable.tableClass}
                                            config={this.configDatatable}
                                            records={this.state.rows}
                                            columns={this.columns}
                                            dynamic={true}
                                            minWidth={1000}
                                            total_record={this.state.totalRow}
                                            initial={this.state.filter}
                                            onChange={(filter) => {
                                                this.setState({
                                                    loadingTable: true,
                                                    filter: filter
                                                }, function () {
                                                    this.setTokenAPI()
                                                });
                                            }}
                                            loading={this.state.loadingTable}
                                        />
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </> }
                <Modal isOpen={this.state.modalShow} size="lg" toggle={this.state.modalToggle}>
                    <AvForm className="needs-validation" onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}>
                        <ModalHeader toggle={this.state.modalToggle}>
                            { this.state.obj !== undefined && this.state.obj !== null ? <>
                                Edit Tim Penialaian 360
                            </> : <>
                                Tambah Tim Penialaian 360
                            </> }
                        </ModalHeader>
                        <ModalBody>
                            <Row className="mb-3">
                                <Label className="col-md-3 col-form-label">
                                   Unit Kerja <span className="text-danger">*</span>
                                </Label>
                                <Col md="9">
                                    <CustomSelect
                                        name={`ms360_team_work_unit_uuid`}
                                        errorMessage="Pilih Unit Kerja"
                                        options={this.state.organizations}
                                        validate={{ required: { value: false } }}
                                        placeholder="Pilih Unit Kerja"
                                        isLoading={false}
                                        defaultValue={this.state.obj?.ms360_team_work_unit_uuid ?? ""}
                                    />
                                </Col>
                            </Row>
                             <Row className="mb-3">
                                <Label className="col-md-3 col-form-label">
                                   Nama Alias
                                </Label>
                                <Col md="9">
                                    <AvField
                                        name="ms360_team_alias"
                                        placeholder={'Silahkan Isi Aliass'}
                                        type="text"
                                        errorMessage=""
                                        className="form-control"
                                        validate={{ required: { value: false } }}
                                        id="ms360_team_alias"
                                        value={this.state.obj?.ms360_team_alias ?? ""}
                                    />
                                </Col>
                            </Row>
                            { this.state.obj !== undefined && this.state.obj !== null ? <>
                            <Row className="mb-3">
                                <Label className="col-md-3 col-form-label">
                                   Ketua Tim <span className="text-danger">*</span>
                                </Label>
                                <Col md="9">
                                    <CustomSelect
                                        name={`ms360_team_leader_uuid`}
                                        errorMessage="Pilih Ketua Tim"
                                        options={this.state.leaders}
                                        validate={{ required: { value: true } }}
                                        placeholder="Pilih Ketua Tim"
                                        isLoading={this.state.loadingLeader}
                                        defaultValue={this.state.obj?.ms360_team_leader_uuid ?? ""}
                                    />
                                </Col>
                            </Row>
                            </> : <></> }
                        </ModalBody>
                        <ModalFooter>
                            <Button color="secondary" onClick={() => { this.setState({ modalShow: false }) }}>
                                Batal
                            </Button>{" "}
                            <Button color="primary" type="submit">
                                 { this.state.obj !== undefined && this.state.obj !== null ? <>
                                    Update
                                </> : <>
                                    Simpan
                                </> }
                            </Button>
                        </ModalFooter>
                    </AvForm>
                    </Modal>
                    <Modal isOpen={this.state.modalConfirm} size="md" toggle={this.state.modalConfirm}>
                        { this.state.loadingGenerate ? <>
                             <ModalHeader toggle={this.state.modalConfirm}>
                                <i className="uil uil-setting me-2"></i>Mempersiapkan Data
                            </ModalHeader>
                            <ModalBody>
                                <div className='p-2'>
                                    Sistem sedang mempersiapkan data tim penilaian, mohon tunggu beberapa saat...
                                </div>
                                <div className="progress">
                                    <div
                                        className="progress-bar progress-bar-striped progress-bar-animated"
                                        role="progressbar"
                                        style={{
                                        width: `${this.state.percentageStatus}%`,
                                        transition: "width 0.05s linear",
                                        }}
                                        aria-valuenow={this.state.percentageStatus}
                                        aria-valuemin={0}
                                        aria-valuemax={100}
                                    >
                                        {this.state.percentageStatus}%
                                    </div>
                                </div>
                            </ModalBody>
                        </> : <>
                            <ModalHeader toggle={this.state.modalConfirm}>
                                <i className="uil uil-setting me-2"></i>Konfirmasi Mapping
                            </ModalHeader>
                            <ModalBody>
                                <p className='text-muted'>
                                    Data akan dipetakan sesuai konfigurasi yang telah Anda tentukan. Pastikan setiap field sumber sudah sesuai dengan field tujuan sebelum melanjutkan.
                                    Apakah Anda yakin ingin menerapkan mapping ini?
                                </p>
                            </ModalBody>
                            <ModalFooter>
                                <Button color="secondary" disabled={this.state.loadingGenerate} onClick={() => {
                                     this.setState({
                                        detailUuid: this.state?.obj?.ms360_team_uuid
                                     })
                                 }}>
                                    Tidak
                                </Button>{" "}
                                <Button color="primary" disabled={this.state.loadingGenerate} onClick={this.mapping}  type="button">
                                    Ya, Mapping
                                </Button>
                            </ModalFooter>
                        </> }
                    </Modal>
                    { this.state.detailUuid !== null ?
                        <Redirect to={"/master/timkerja360.html?section=member&uuid=" + this.state.detailUuid}/>
                    : null }
                    { this.state.redirectBack ?
                        <Redirect to={"/master/timkerja360.html"}/>
                    : null }
                     <ConfirmAlert
                        confirmTitle="Konfirmasi!"
                        confirmInfo={this.state.inactiveUuid ? 'Apakah anda yakin hapus data' : "Apakah anda yakin data tersebut sudah benar?"}
                        loadingTitle="Mengirim data..."
                        loadingInfo="Tunggu beberapa saat"
                        successTitle="Berhasil!"
                        successInfo={'Data berhasil diperbaharui'}
                        failedTitle="Gagal!"
                        failedInfo={this.state.messageFailed}
                        showConfirm={this.state.confirm}
                        showLoading={this.state.loading}
                        showSuccess={this.state.success}
                        showFailed={this.state.failed}
                        response={this.confirmResponse}
                    />
            </Fragment>
        )
    }

}

export default TeamComponent
